import React from 'react';
import { createSvgIcon } from '@material-ui/core/utils';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3.369 4.75h17.263v2.074H3.369V4.75zm0 4.138h12.436v2.074H3.369V8.888zm0 4.149h7.948v2.074H3.369v-2.074zm0 4.139h4.149v2.074H3.369v-2.074z"
}), 'SortDesc');